import { useEffect, useRef } from 'react'
import { MultiGrid, InfiniteLoader } from 'react-virtualized'
import { useSpreadSheetData } from './SpreadSheetDataProvider'
import { useTableData } from './TableDataProvider'
import { useHelpers } from './SpreadSheetHelpersProvider'
import { Loading } from 'Components'
import { Empty, Spin } from 'antd'
import {
  BaseCell,
  BodyCell,
  AnchorCell,
  ColHeaderCell,
  HeaderCell
} from './renderers'
import SpreadSheetShortcuts from './SpreadSheetShortcuts'
import 'react-virtualized/styles.css'
import './SpreadSheet.scss'

SpreadsheetLoading = ->
  <div style={{ position: 'absolute', marginLeft: 50, width: 'calc(100% - 50px)', opacity: 0.3, zIndex: 9999 }}>
    <Loading />
  </div>

SpreadSheet = ({
  width,
  height,
  cellHeight
}) ->

  [{
    columnWidths,
    columns,
    count,
    isFetching,
    resizedColumnWidths,
    selection
  }] = useSpreadSheetData()

  [tableData] = useTableData()

  {
    columnCount,
    columnWidthMultiplier,
    getColumnWidth,
    getTableWidth,
    headerColumnWidth,
    loadMore,
    setColumnWidthMultiplier
  } = useHelpers()


  spreadsheetRef = useRef(null)

  useEffect( ->
    spreadsheetRef.current.recomputeGridSize()
    undefined
  , [columnWidths])

  isRowLoaded = ({ index }) ->
    !!tableData[index]

  loadMoreRows = _.debounce(
    ({ startIndex, stopIndex }) ->
      loadMore(startIndex, stopIndex)
    , 100
    , { leading: false, trailing: true }
  )

  cellRenderer = ({ props... }) ->
    { columnIndex, rowIndex } = props
    if columnIndex > 0 and rowIndex > 0
      bodyProps = { props..., columnIndex: columnIndex - 1, rowIndex: rowIndex - 1 }
      <BodyCell { bodyProps... } />
    else if rowIndex > 0
      colHeaderProps = { props..., rowIndex: rowIndex - 1 }
      <ColHeaderCell { colHeaderProps... } />
    else if columnIndex > 0
      headerProps = { props..., columnIndex: columnIndex - 1 }
      <HeaderCell { headerProps... } />
    else
      <AnchorCell { props... } />

  <>
    {if isFetching then <SpreadsheetLoading />}
    <InfiniteLoader
      isRowLoaded={isRowLoaded}
      loadMoreRows={loadMoreRows}
      rowCount={count}
      threshold={0}
    >
      {({ onRowsRendered, registerChild }) ->

        registerChild(spreadsheetRef.current)
        ### The `+ 1` magic numbers represent the column headers. ###

        onSectionRendered = ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }) ->
          onRowsRendered({
            startIndex: rowStartIndex,
            stopIndex: rowStopIndex
          })
        <MultiGrid
          classNameBottomRightGrid="body-grid"
          cellRenderer={cellRenderer}
          columnWidth={({ index }) -> getColumnWidth({ index })}
          columnCount={columnCount + 1}
          fixedColumnCount={1}
          fixedRowCount={1}
          height={height}
          overscanRowCount={0}
          rowHeight={cellHeight}
          rowCount={Math.max(count + 1, 31)}
          width={width}
          ref={spreadsheetRef}
          onSectionRendered={onSectionRendered}
          hideTopRightGridScrollbar
          hideBottomLeftGridScrollbar
        />
      }
    </InfiniteLoader>
  </>

export default SpreadSheet
